// 'use strict'

var util = require('../helpers/util')
var spinner = require('polythene/spinner/indeterminate-spinner')
var searchCmp = require('polythene/search/search')
require('polythene/common/object.assign')

let search = {}


search.view = function(ctrl, args) {
	return m(".col-md-4.col-xs-12", [
		// m("p.usage", mx.translate('modules.localization.usage')),
		m.component(searchCmp, {
			// type: 'inset',
			// borders: true,
			textfield: {
				class : 'form-control input-lg',
        label : mx.translate('modules.localization.placeholder'),
				help : mx.translate('modules.localization.usage'),
				focusHelp : true,
				// dense: true,
				// floatingLabel: true,
				autofocus : true
    	},
			events : {
				oninput : (event) => args.runSearch(event.target.value)
			}
		}),

		m.trust('<br/>'),
		m.trust('<br/>'),

		m.component(spinner, {
	    // singleColor: true,
	    type: 'medium',
			show: args.loading(),
    	hide: !args.loading()
		}),

    args.data().length > 0	? m("#results", [
			args.data()
			.filter(args.filter)
			.unique("term")
			.map(function(item, index) {
				return args.decorator(item, index)
			})
		]) :
		null
		// m("p#results", "No results")
	])
}

export default search
